/*
 * @Author: Teemo Ding
 * @Date: 2021-08-18 08:55:47
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 10:33:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/GuestCheckoutCustomerInformation/index.tsx
 */
import React from 'react';
// import { CheckoutErrorContext } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/ErrorContext';
import InformationSelection from 'src/constrains/InformationFieldsSelectTable';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const GuestCheckoutCustomerInformation = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const { guestCheckoutEmptyError, setGuestCheckoutEmptyError } =
  //   React.useContext(CheckoutErrorContext);
  const { data, onChange, setHasModified, fields, disableEdit } = props;

  return (
    <SectionWrapper
      subtitle={getI18n(
        'salesChannelCheckout.index.guestCheckoutCustomerInformationSub',
      )}
      title={getI18n(
        'salesChannelCheckout.index.guestCheckoutCustomerInformationTitle',
      )}>
      <InformationSelection
        isOptOptional
        data={data}
        disableEdit={disableEdit}
        setHasModified={setHasModified}
        onChange={onChange}
        id='SalesChannelCheckoutCustomerInfoTable'
        fields={fields}
        // error={{
        //   emptyError: guestCheckoutEmptyError,
        //   setEmptyError: setGuestCheckoutEmptyError,
        // }}
        tip={getI18n(
          'salesChannelCheckout.index.guestCheckoutCustomerInformationTip',
        )}
      />
    </SectionWrapper>
  );
};
export default GuestCheckoutCustomerInformation;
